import { render } from "./Dependentes.vue?vue&type=template&id=5fa467f2&scoped=true"
import script from "./Dependentes.vue?vue&type=script&lang=js"
export * from "./Dependentes.vue?vue&type=script&lang=js"

import "./Dependentes.vue?vue&type=style&index=0&id=5fa467f2&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa467f2"]])

export default __exports__